import React, { createContext, useContext } from 'react';
const SharedExperiencePageContext = createContext();
export const useSharedExperiencePageContext = () => {
  const context = useContext(SharedExperiencePageContext);
  if (!context) {
    throw new Error('useSharedExperiencePageContext must be used within a SharedExperiencePageProvider');
  }
  return context;
};
export { SharedExperiencePageContext }; 